import { createEnv } from '@t3-oss/env-nextjs';
import { z } from 'zod';

export const env = createEnv({
  skipValidation: !!process.env.SKIP_ENV_VALIDATION,
  server: {
    SUPABASE_SERVICE_KEY: z.string(),
    SUPABASE_AUDIT_PINGBACK_URL: z.string().url().optional(),
    GOOGLE_CLIENT_ID: z.string(),
    GOOGLE_CLIENT_SECRET: z.string(),
    GSC_WEBHOOK_SECRET: z.string(),
    RANK_TRACKER_WEBHOOK_SECRET: z.string(),
    POSTHOG_ENV_ID: z.string(),
    POSTHOG_PERSONAL_API_KEY: z.string(),
    POSTHOG_ENABLE_SOURCE_MAP_UPLOAD: z.coerce.boolean().optional(),
    STRIPE_SECRET_KEY: z.string(),
    STRIPE_WEBHOOK_SECRET: z.string(),
    RESEND_API_KEY: z.string(),
    GCC_API_KEY: z.string(),
    // Citation Tracker APIs
    DATAFORSEO_USERNAME: z.string(),
    DATAFORSEO_PASSWORD: z.string(),
    DOMDETAILER_API_KEY: z.string(),
    OPENROUTER_API_KEY: z.string(),
    // GBP Specific
    GOOGLE_PLACES_API_KEY: z
      .string()
      .optional()

      .default('AIzaSyDOTK7DSB86D5v5TNkBptg6Iwgf53LJgtk'),
    SCRAPINGBEE_API_KEY: z
      .string()
      .optional()
      .default(
        'AIAITCT149OZZ0XR4CYJIB4YZC6V3XH4SSV9643ZNTR2J9GRL101L9SJ69V1YOS7DT8SQR4PFEUXFCHL',
      ),
    INSTANTLY_API_KEY: z
      .string()
      .optional()
      .default('Cwwknaq02ffBuhvTpTgSDbyAw'),
    PLEPER_API_KEY: z
      .string()
      .optional()
      .default('7cd600d8675ee79cd0fd57194f1506bb'),
    PLEPER_API_SIGNATURE: z
      .string()
      .optional()
      .default('d50856e1feb88a6cf0d1c774c00fd41062d3592b'),
  },
  client: {
    NEXT_PUBLIC_SUPABASE_URL: z.string(),
    NEXT_PUBLIC_SUPABASE_ANON_KEY: z.string(),
    NEXT_PUBLIC_DARK_MODE: z.coerce.boolean().optional(),
    NEXT_PUBLIC_TEST_MODE: z.coerce.boolean().optional(),
    NEXT_PUBLIC_SANDBOX_ENABLED: z.coerce.boolean().optional(),
    NEXT_PUBLIC_APP_URL: z.string(),
    NEXT_PUBLIC_APP_NAME: z.string().optional().default('SEOMaven AI'),
    NEXT_PUBLIC_POSTHOG_KEY: z.string(),
    NEXT_PUBLIC_POSTHOG_HOST: z.string(),
    NEXT_PUBLIC_GEOGRID_URL: z.string(),
  },
  runtimeEnv: {
    GOOGLE_CLIENT_ID: process.env.GOOGLE_CLIENT_ID,
    GOOGLE_CLIENT_SECRET: process.env.GOOGLE_CLIENT_SECRET,
    GSC_WEBHOOK_SECRET: process.env.GSC_WEBHOOK_SECRET,
    NEXT_PUBLIC_SUPABASE_URL: process.env.NEXT_PUBLIC_SUPABASE_URL,
    NEXT_PUBLIC_SUPABASE_ANON_KEY: process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY,
    NEXT_PUBLIC_DARK_MODE: process.env.NEXT_PUBLIC_DARK_MODE,
    NEXT_PUBLIC_TEST_MODE: process.env.NEXT_PUBLIC_TEST_MODE,
    NEXT_PUBLIC_SANDBOX_ENABLED: process.env.NEXT_PUBLIC_SANDBOX_ENABLED,
    SUPABASE_SERVICE_KEY: process.env.SUPABASE_SERVICE_KEY,
    SUPABASE_AUDIT_PINGBACK_URL: process.env.SUPABASE_AUDIT_PINGBACK_URL,
    NEXT_PUBLIC_APP_URL: process.env.NEXT_PUBLIC_APP_URL,
    NEXT_PUBLIC_APP_NAME: process.env.NEXT_PUBLIC_APP_NAME,
    NEXT_PUBLIC_POSTHOG_KEY: process.env.NEXT_PUBLIC_POSTHOG_KEY,
    NEXT_PUBLIC_POSTHOG_HOST: process.env.NEXT_PUBLIC_POSTHOG_HOST,
    RANK_TRACKER_WEBHOOK_SECRET: process.env.RANK_TRACKER_WEBHOOK_SECRET,
    POSTHOG_ENV_ID: process.env.POSTHOG_ENV_ID,
    POSTHOG_PERSONAL_API_KEY: process.env.POSTHOG_PERSONAL_API_KEY,
    POSTHOG_ENABLE_SOURCE_MAP_UPLOAD:
      process.env.POSTHOG_ENABLE_SOURCE_MAP_UPLOAD,
    NEXT_PUBLIC_GEOGRID_URL: process.env.NEXT_PUBLIC_GEOGRID_URL,
    STRIPE_SECRET_KEY: process.env.STRIPE_SECRET_KEY,
    STRIPE_WEBHOOK_SECRET: process.env.STRIPE_WEBHOOK_SECRET,
    RESEND_API_KEY: process.env.RESEND_API_KEY,
    GCC_API_KEY: process.env.GCC_API_KEY,
    PLEPER_API_KEY: process.env.PLEPER_API_KEY,
    PLEPER_API_SIGNATURE: process.env.PLEPER_API_SIGNATURE,
    // Citation Tracker APIs
    DATAFORSEO_USERNAME: process.env.DATAFORSEO_USERNAME,
    DATAFORSEO_PASSWORD: process.env.DATAFORSEO_PASSWORD,
    DOMDETAILER_API_KEY: process.env.DOMDETAILER_API_KEY,
    OPENROUTER_API_KEY: process.env.OPENROUTER_API_KEY,
    // GBP Specific
    GOOGLE_PLACES_API_KEY: process.env.GOOGLE_PLACES_API_KEY,
    SCRAPINGBEE_API_KEY: process.env.SCRAPINGBEE_API_KEY,
    INSTANTLY_API_KEY: process.env.INSTANTLY_API_KEY,
  },
});
